<script>
import messages from "../../mixins/messages";
import toasts from "../../mixins/toasts";

export default Vue.extend({
  mixins: [messages, toasts],
  data() {
    return {
      modified: false,
      subject: null
    };
  },
  mounted() {
    this.modified = false;
  },
  methods: {
    update(subject) {
      this.modified = true;
      this.subject = subject;
    },
    submit() {
      if (!this.modified) {
        return;
      }

      this.modified = false;
      let loading = this.$loading.open();
      axios
        .post("/api/subjects", this.subject)
        .then(response => {
          this.toast("success", "Предмет был успешно создан");
          _.delay(() => {
            window.open(`/subjects/${response.data.id}`, "_self");
          }, 2000);
        })
        .catch(error => {
          loading.close();
          switch (error.response.status) {
            case 422: {
              let errors = error.response.data.errors;
              let key = _.first(_.keys(errors));
              this.toast("warning", _.first(errors[key]));
              break;
            }
            case 403: {
              this.toast(
                "warning",
                "Создание предмета с такими параметрами недоступно"
              );
              break;
            }
            default: {
              this.modified = true;
              this.toast("error", "@unexpected", error);
              break;
            }
          }
        });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/subjects/Create.vue